export default __webpack_public_path__ + "static/media/heart.2f5b2447.png";